import app from '@/app';
import templateUrl from './measurement-kartado-search.html';

/* @ngInject */
function MeasurementSearchController(
  $controller,
  $state,
  $timeout,
  $uibModal,
  Upload,
  $http,
  Principal,
  DialogService
) {
  var $ctrl = this;
  $controller('AbstractController', { $ctrl });

  const transition = $ctrl.transition;

  $ctrl.currentAccount = null;

  $ctrl.filters = [{ measurement: null, metric: null }];

  const mapMetrics = [
    'd0',
    'd20',
    'd30',
    'd45',
    'd60',
    'd90',
    'd120',
    'force',
    'airTemperature',
    'pavementTemperature',
    'radius',
    'iriAverage',
    'qiAverage',
    'innerFl',
    'outerFl',
    'atrAverage',
    'igg',
    'density',
    'hrb',
    'mct',
    'moisture',
    'll',
    'lp',
    'ip',
    'granulometryN40',
    'granulometryN10',
    'granulometryN40',
    'granulometryN200',
    'max',
    'hot',
    'exp',
    'cbr',
    'fc1',
    'fc2',
    'fc3',
    'pothole',
    'sinking',
    'others',
    'lightVehicleDailyAverage',
    'heavyVehicleDailyAverage',
    'usaceVehicleFactor',
    'aashtoVehicleFactor',
    'hs',
    'vrd',
    'macrotextureMeasure',
    'microtextureMeasure',
    'fr60',
    'ifiSp',
    'ifiF60',
    'urci',
    'layer1thickness',
    'layer2thickness',
    'layer3thickness',
    'layer4thickness',
    'layer1Material',
    'layer2Material',
    'layer3Material',
    'layer4Material',
    'speed',
    'noise',
    'icp'
  ];

  $ctrl.templates =
    [
      { name: "Ensaios", path: "ensaios" },
      { name: "Estrutura", path: "estrutura" },
      { name: "FWD", path: "fwd" },
      { name: "GN", path: "gn" },
      { name: "HS", path: "hs" },
      { name: "ICP", path: "icp" },
      { name: "IFI", path: "ifi" },
      { name: "IGG", path: "igg" },
      { name: "IRI", path: "iri" },
      { name: "Obras Executadas", path: "obras-executadas" },
      { name: "Pesagem", path: "pesagem" },
      { name: "Ruído", path: "ruido" },
      { name: "Sondagem", path: "sondagem" },
      { name: "Tráfego", path: "trafego" },
      { name: "TR", path: "tr" },
      { name: "Unifilar Obras Executadas", path: "unifilar-obras" },
      { name: "URCI", path: "urci" },
      { name: "VRD", path: "vrd" },
    ]

  Principal.identity().then(account => {
    $ctrl.currentAccount = account;
  });

  $ctrl.transition = params => {
    transition(params);

    $ctrl.organization = $ctrl.allOrganizations.content.find(
      it => it.id == params.organization
    );
    $ctrl.road = $ctrl.allRoads.content.find(it => {
      return it.id == params.road && it.roadtype == params.roadtype;
    });

    if ($ctrl.road) {
      $ctrl.headMilestone = _.defaultTo(
        _.defaultTo(null, $ctrl.road.headMilestone),
        parseFloat(params.headMilestone)
      );
      $ctrl.tailMilestone = _.defaultTo(
        _.defaultTo(null, $ctrl.road.tailMilestone),
        parseFloat(params.tailMilestone)
      );

      $ctrl.lanes = _.flow(_.keyBy(_.identity), _.at(params.lanes))($ctrl.road.lanesRoad);
      $ctrl.lanes = $ctrl.lanes.filter(lane => lane !== null);
    }
    $ctrl.direction = params.direction;
    $ctrl.campaigns = _.flow(
      _.keyBy('id'),
      _.at(params.campaigns || [])
    )($ctrl.allCampaigns.content);
    $ctrl.output = params.output;
    $ctrl.roadtype = params.roadtype;
    if (params.filters) {
      $ctrl.filters = [];
      angular.forEach(JSON.parse(params.filters), function (item, key) {
        var filter = {
          measurement: $ctrl.allMeasurements.find(it => it.code == item.measurement.code),
          metric: item.metric
        };

        $ctrl.filters.push(filter);
      });
    }
  };


  $ctrl.onOrganizationChange = organization => {
    $ctrl.roadtype = 'ROAD';
    $ctrl.road = null;
    $ctrl.lanes = [];
    $ctrl.headMilestone = null;
    $ctrl.tailMilestone = null;
    $ctrl.campaigns = [];
  };

  $ctrl.upload = files => {
    if (!$ctrl.readonly && files && files.length) {
      $uibModal
        .open({
          component: 'measurementImportDialog',
          backdrop: 'false',
          resolve: {
            measurement: () => $ctrl.measurement,
            files: () => files
          }
        })
        .result.then($ctrl.onImportFinish, $ctrl.onImportFinish);
    }
  };

  $ctrl.onImportFinish = () => {
    $state.reload();
  };

  $ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

  $ctrl.onRoadSelected = road => {
    $ctrl.lanes = [];
    $ctrl.headMilestone = road.headMilestone;
    $ctrl.tailMilestone = road.tailMilestone;
  };

  $ctrl.filterAllMetrics = item => {
    if (item.measurement) {
      switch ($ctrl.output) {
        case 'table':
          return [];
        case 'line-chart':
          return $ctrl.allMetrics.filter(
            metric =>
              item.measurement.code == metric.measurement && $ctrl.icpFilter(metric)
          );
        case 'pie-chart':
          if (item.measurement && $ctrl.allMetricLimits.$resolved) {
            return $ctrl.allMetrics.filter(
              metric =>
                $ctrl.icpFilter(metric) &&
                item.measurement.code == metric.measurement &&
                $ctrl.allMetricLimits.content
                  .filter(item => item.organization.id == $ctrl.organization.id)
                  .some(limit => metric.code == limit.metric)
            );
          }
        case 'map':
          var result = $ctrl.allMetrics.filter(
            metric =>
              item.measurement.code == metric.measurement &&
              mapMetrics.indexOf(metric.name) !== -1
          );
          if (item.measurement.code == 'IRI') {
            return result.filter(m => m.code != 'IRI_SPEED');
          } else {
            return result;
          }
      }
    }
  };

  $ctrl.icpFilter = metric => {
    if (metric.measurement === 'ICP') {
      return metric.code === 'ICP_ICP';
    } else {
      return true;
    }
  };

  $ctrl.filterAllMetrics = (item) => {
    if (item.measurement) {
      switch ($ctrl.output) {
        case 'table':
          return [];
        case 'line-chart':
          return $ctrl.allMetrics.filter(metric => item.measurement.code == metric.measurement);
        case 'pie-chart':
          if (item.measurement && $ctrl.allMetricLimits.$resolved) {
            return $ctrl.allMetrics.filter(metric =>
              item.measurement.code == metric.measurement &&
              $ctrl.allMetricLimits.content
                .filter(item => item.organization.id == $ctrl.organization.id)
                .some(limit => metric.code == limit.metric)
            );
          }
        case 'map':
          var result = $ctrl.allMetrics.filter(metric => item.measurement.code == metric.measurement && (mapMetrics.indexOf(metric.name) !== -1));
          if (item.measurement.code == "IRI") {
            return result.filter(m => m.code != "IRI_SPEED");
          } else {
            return result;
          }
      }
    }
  };

  // ---------------------------------------------------------------------
  // ✅ Debounce de chamadas ao backend (500ms) usando $timeout
  // ---------------------------------------------------------------------
  let queryTimeout = null;

  // ==========================================================
  // 1. CONFIGURAÇÕES E VARIÁVEIS DE ESTADO
  // ==========================================================

  $ctrl.apiBaseUrl = '/api/metadata/kartado';
  $ctrl.queryTimeout = null;
  $ctrl.isLoading = false;

  // Variáveis de controle da Tabela (necessárias para wf-table-holder)
  $ctrl.entities = []; // Dados que preencherão o <tbody>
  $ctrl.count = 0;    // Total de itens para a paginação
  $ctrl.page = 1;     // Página atual
  $ctrl.size = 10;    // Tamanho da página
  $ctrl.sort = null;  // Campo de ordenação
  $ctrl.metrics = []; // Deve ser definido aqui (dependente do seu contexto)

  // Variáveis Dinâmicas da Query
  $ctrl.companyId = 'af087987-e1cd-47e0-8885-d306d5da6821';
  $ctrl.pageNumber = 1;
  $ctrl.pageSize = 10;
  $ctrl.roadName = 'Acesso BR-277'; // Exemplo de nome de estrada

  // ==========================================================
  // 2. FUNÇÃO DE MAPEAMENTO DE DADOS
  // ==========================================================

  // Esta função garante que o objeto retornado do Kartado
  // se encaixe na estrutura esperada pelo $ctrl.entities
  function mapKartadoItemToEntity(kartadoItem) {
    // Ajuste para campanha: se for null, usamos um objeto com nome vazio
    const campaign = kartadoItem.campaign || { name: '' };

    return {
      // Propriedades aninhadas
      organization: kartadoItem.organization,
      road: kartadoItem.road,
      campaign: kartadoItem.campaign,

      // Propriedades diretas
      headMilestone: kartadoItem.headMilestone,
      tailMilestone: kartadoItem.tailMilestone,
      direction: kartadoItem.direction,
      lane: kartadoItem.lane,
      dateTime: kartadoItem.dateTime,
      comments: kartadoItem.comments,
      markerKilometer: kartadoItem.markerKilometer,
      milestone: kartadoItem.milestone,

      // Métrica customizada 'Extension' (Exemplo)
      extension: kartadoItem.extension,

      // Se sua métrica for 'Icp' no HTML, verifique qual campo do Kartado usar
      Icp: kartadoItem.icp,

      // Adicione outras métricas aqui se necessário
      // Exemplo: Solution (se existir uma coluna para isso)
      solution: kartadoItem.solution
    };
  }


  // ==========================================================
  // 3. FUNÇÕES DE REQUISIÇÃO E CONTROLE DA TABELA
  // ==========================================================

  // Função principal para buscar dados da API
  $ctrl.onQueryChange = function () {
    if ($ctrl.queryTimeout) {
      $timeout.cancel($ctrl.queryTimeout);
    }

    $ctrl.queryTimeout = $timeout(() => {
      const params = {
        company: $ctrl.companyId,
        page: $ctrl.pageNumber, // Pode usar $ctrl.page
        page_size: $ctrl.pageSize, // Pode usar $ctrl.size
        roadKartadoName: $ctrl.roadName
      };

      $ctrl.isLoading = true;

      $http.get($ctrl.apiBaseUrl)
        .then(function (response) {
          const kartadoData = response.data;

          if (kartadoData) {
            // Mapeia e atribui os dados ao $ctrl.entities
            $ctrl.entities = kartadoData;//.content.map(mapKartadoItemToEntity);
          } else {
            $ctrl.entities = [];
          }

          // Atualiza a contagem total para a paginação
          $ctrl.count = kartadoData && kartadoData.totalElements !== undefined
            ? kartadoData.totalElements
            : $ctrl.entities.length;
        })
        .catch(function (error) {
          console.error('Erro ao buscar informações do Kartado:', error);
          $ctrl.entities = [];
          $ctrl.count = 0;
          $ctrl.pageNumber = 1;
          $ctrl.pageSize = 10;
        })
        .finally(function () {
          $ctrl.isLoading = false;
        });
    }, 500); // debounce 500ms
  };

  // Função chamada pelo wf-table-holder para gerenciar paginação/ordenação
  $ctrl.onPageSortChange = function (page, size, sort) {
    $ctrl.page = page;
    $ctrl.size = size;
    $ctrl.sort = sort;

    // Atualiza os parâmetros da query para refletir a nova página/tamanho
    $ctrl.pageNumber = page;
    $ctrl.pageSize = size;

    // Dispara a nova busca com os parâmetros atualizados
    $ctrl.onQueryChange();
  };

  // Inicialização: Chama a busca quando o controller é carregado
  $ctrl.$onInit = function () {
    // Simula o carregamento inicial dos dados na primeira página
    $ctrl.onQueryChange();
  };



  $ctrl.addFilter = function () {
    if ($ctrl.filters.length == 5) {
      DialogService.alertMessage("Limite de filtros: 5");
      return;
    }
    $ctrl.filters.push({ measurement: null, metric: null });
  };

  $ctrl.removeFilter = function (index) {
    $ctrl.filters.splice(index, 1);
  };

}

const component = {
  templateUrl,
  controller: MeasurementSearchController,
  bindings: {
    allResources: '<',
    allOrganizations: '<',
    allRoads: '<',
    allCampaigns: '<',
    allMeasurements: '<',
    allMetrics: '<',
    allMetricLimits: '<',
    $transition$: '<'
  }
};

app.component('measurementKartadoSearch', component);
